import {useHistoryMaterialsById} from '@domain/materials'
import {dataTestId} from '@hconnect/uikit'
import {Card} from '@hconnect/uikit/src/lib2'
import {useUpmPlantContext} from '@hconnect/upm'
import {Skeleton, Stack} from '@mui/material'
import React from 'react'
import {Trans} from 'react-i18next'

import {useProducedAndForecastedMaterials, useSelectedTimeframe} from '../../hooks'
import {InfoCaption} from '../shared'

import {ProductionSummaryCardHeader} from './ProductionSummaryCardHeader'
import {ProductionSummaryTable} from './ProductionSummaryTable'

const PRODUCTION_SUMMARY_TABLE_SKELETON_HEIGHT = 300

export const ProductionSummaryCard: React.FC = () => {
  const {plantId} = useUpmPlantContext()
  const {selectedTimeframe} = useSelectedTimeframe()
  if (!selectedTimeframe) {
    throw new Error('BUG: selectedTimeframe is not defined')
  }

  const {data: producedAndForecastedMaterialData} = useProducedAndForecastedMaterials({
    timeFrame: selectedTimeframe
  })

  const {data: materialsById} = useHistoryMaterialsById({plantId, timeFrame: selectedTimeframe})

  return (
    <Card
      headerContent={<ProductionSummaryCardHeader />}
      {...dataTestId('production_summary_card')}
    >
      <Stack spacing={2}>
        <InfoCaption>
          <Trans i18nKey="planning.productionSummaryDescription" components={{1: <strong />}} />
        </InfoCaption>
        {producedAndForecastedMaterialData ? (
          <ProductionSummaryTable
            data={producedAndForecastedMaterialData}
            materialsById={materialsById}
          />
        ) : (
          <Skeleton variant="rectangular" height={PRODUCTION_SUMMARY_TABLE_SKELETON_HEIGHT} />
        )}
      </Stack>
    </Card>
  )
}
